import './SortTable.scss';
import Component from './SortTable.js';
export default Component;
